import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import UploadPlanilha from './UploadPlanilha';
import UploadIndicadores from './UploadIndicadores';
import UploadVisitas from './UploadVisitas';
import UploadProntuario from './UploadProntuario';
import UploadOrcamentos from './UploadOrcamentos';
import UploadContasEnviadas from './UploadContasEnviadas';
import UploadVisitasProdutividade from './UploadVisitasProdutividade';

const TABS = [
  { k: 'visitas',      l: '🏥 Visitas Domiciliares', C: UploadVisitas },
  { k: 'telefonia',    l: '📞 Telefonia',             C: UploadPlanilha },
  { k: 'indicadores',  l: '🏠 Censo Homecare',        C: UploadIndicadores },
  { k: 'prontuario',   l: '📄 Prontuários',            C: UploadProntuario },
  { k: 'orcamentos',   l: '💰 Orçamentos',             C: UploadOrcamentos },
  { k: 'contas',       l: '📤 Contas Enviadas',        C: UploadContasEnviadas },
  { k: 'visitas-prod', l: '🏠 Visitas × Produtiv.',    C: UploadVisitasProdutividade },
];

export default function UploadHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabQuery = searchParams.get('tab');

  const getValidTab = (val) => TABS.some(t => t.k === val) ? val : 'visitas';
  const [tab, setTab] = useState(() => getValidTab(tabQuery));

  useEffect(() => {
    const valid = getValidTab(tabQuery);
    if (valid !== tab) {
      setTab(valid);
    }
  }, [tabQuery]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleTabChange = (newTab) => {
    setTab(newTab);
    setSearchParams({ tab: newTab });
  };

  const Active = TABS.find(t => t.k === tab)?.C;

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', padding: '18px 28px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ fontSize: 20 }}>📤</span>
          <span style={{ color: '#fff', fontWeight: 800, fontSize: '1.05rem' }}>Central de Uploads</span>
          <span style={{ color: '#64748b', fontSize: '0.78rem', marginLeft: 4 }}>Importe planilhas para cada módulo</span>
        </div>
        {/* Abas */}
        <div style={{ display: 'flex', gap: 4 }}>
          {TABS.map(t => (
            <button key={t.k} onClick={() => handleTabChange(t.k)}
              style={{
                border: 'none', padding: '8px 18px', cursor: 'pointer',
                fontSize: '0.82rem', fontWeight: 700,
                borderRadius: '8px 8px 0 0', transition: 'all 0.15s',
                background: tab === t.k ? '#f8fafc' : 'rgba(255,255,255,0.08)',
                color: tab === t.k ? '#1e293b' : 'rgba(255,255,255,0.7)',
                borderBottom: tab === t.k ? '2px solid #6366f1' : '2px solid transparent',
              }}>
              {t.l}
            </button>
          ))}
        </div>
      </div>

      {/* Conteúdo da aba */}
      <div style={{ padding: '0' }}>
        {Active && <Active />}
      </div>
    </div>
  );
}
